//import { AxiosResponse } from 'axios'
//import qs from 'querystring'
import qs from 'querystring'
import { AppointmentRequest, CTLLifestyleFormValues } from 'types/Appointment'
//import { AvailabilityFormValues } from '../Pages/AppointmentPage/components/AvailabilityForm'
import { useApi } from './useAPI'

interface Props {
  token: string | undefined
}

export default function useNewEnrollment({ token }: Props) {
  const TriaApi = useApi(token)
  const getEligibility = async () => {
    const result = TriaApi.get(`api/newEnrollment/eligibility`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return result
  }

  const postCTLLifestyle = async (values: CTLLifestyleFormValues) => {
    const {
      reasonForChange,
      readinessToChange,
      dietVariety,
      mealsSameTime,
      cookingSkills,
      dietStrategy,
      livingSituation,
      householdMembersTryingToLoseWeight,
      timeForYourself,
      obligations,
      activityLevel,
      livingSituationNote,
      obligationsNote,
      reasonForChangeNote,
      heightFeet,
      heightInches,
      weight,
      weightBeforeMeds,
      goalWeight,
      ctl,
    } = values

    const data = qs.stringify({
      ReasonForChange: reasonForChange,
      ReadinessToChange: readinessToChange,
      DietVariety: dietVariety,
      MealsSameTime: mealsSameTime,
      CookingSkills: cookingSkills,
      DietStrategy: dietStrategy,
      LivingSituation: livingSituation,
      HouseholdMembersTryingToLoseWeight: householdMembersTryingToLoseWeight,
      TimeForYourself: timeForYourself,
      Obligations: obligations,
      ActivityLevel: activityLevel,
      LivingSituationNote: livingSituationNote,
      ObligationsNote: obligationsNote,
      ReasonForChangeNote: reasonForChangeNote,
      HeightFeet: heightFeet,
      HeightInches: heightInches,
      Weight: weight,
      WeightBeforeMeds: weightBeforeMeds,
      GoalWeight: goalWeight,
      CTL: ctl,
    })

    const response = TriaApi.post(`api/newEnrollment/lifestyle-ctl`, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })

    return response
  }

  const getInitialAppointments = async (ctl: boolean) => {
    if (ctl) {
      const response = TriaApi.get(`api/newEnrollment/appointment/ctl`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response
    } else {
      const response = TriaApi.get(`api/newEnrollment/appointment`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response
    }
  }
  interface ApptProps {
    ctl?: boolean
    pa?: boolean
  }

  const getInitial = async ({ ctl = false, pa = false }: ApptProps) => {
    if (ctl) {
      const response = TriaApi.get(`api/newEnrollment/Initial/ctl`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response
    } else if (pa) {
      const response = TriaApi.get(`api/newEnrollment/Initial/pa`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response
    } else {
      const response = TriaApi.get(`api/newEnrollment/Initial`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response
    }
  }

  const getScheduleCards = async () => {
    const response = TriaApi.get(`api/newEnrollment/scheduleCards`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })

    return response
  }
  const postEnrollmentForm = async (ctl: boolean) => {
    const data = qs.stringify({
      CTL: ctl,
    })

    const response = TriaApi.post(`api/newEnrollment/enrollmentForm`, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })

    return response
  }

  const postInitialAppointment = async (values: AppointmentRequest, ctl: boolean) => {
    const data = qs.stringify({
      ImmediateAppointment: values.immediateAppointment,
      StartTime: values.startTime,
      EndTime: values.endTime,
      Pharmacist: values.pharmacist,
      ScheduleId: values.scheduleId,
    })

    if (!ctl) {
      const response = TriaApi.post(`api/newEnrollment/appointment`, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })

      return response
    } else {
      const response = TriaApi.post(`api/newEnrollment/appointment/ctl`, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })

      return response
    }
  }

  const postPhone = async (values: { deviceType: number; phone: string; optIn: boolean }) => {
    const data = qs.stringify({
      Phone: values.phone,
      DeviceType: values.deviceType,
      SmsOptIn: values.optIn,
    })

    const response = TriaApi.post(`api/newEnrollment/phone`, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })

    return response
  }

  return {
    getEligibility,
    postInitialAppointment,
    postCTLLifestyle,
    getInitialAppointments,
    getInitial,
    getScheduleCards,
    postPhone,
    postEnrollmentForm,
  }
}

export interface WelltrakRequest {
  enrollmentFormGuid?: string
  welltrakID?: string
}

export interface DemographicsRequest {
  firstName: string
  lastName: string
  email: string
  phone: string
  zipCode: string
  dateOfBirth: string
}
